export type SwipeOption = {
  onSwipeRight?: () => void;
  onSwipeLeft?: () => void;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
};

export function swipe(el: HTMLElement, option: SwipeOption) {
  let xDown: number | null = null;
  let yDown: number | null = null;

  function handleTouchStart(evt: TouchEvent) {
    const firstTouch = evt.touches[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt: TouchEvent) {
    if (!xDown || !yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = xDown - xUp;
    const yDiff = yDown - yUp;

    if (process.env.NODE_ENV == "development") {
      console.log("xDiff, yDiff:", xDiff, yDiff);
    }

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* right swipe */
        option.onSwipeRight && option.onSwipeRight();
      } else {
        /* left swipe */
        option.onSwipeLeft && option.onSwipeLeft();
      }
    } else {
      if (yDiff < 0) {
        /* down swipe */
        option.onSwipeDown && option.onSwipeDown();
      } else {
        /* up swipe */
        option.onSwipeUp && option.onSwipeUp();
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }

  el.addEventListener("touchstart", handleTouchStart, false);
  el.addEventListener("touchmove", handleTouchMove, false);
}
